import logger from '../../utils/logger';

export const controlFlowRate = (rootStore, scale, scalePorts, flowRate, binForDecum, runningData) => {
  const { batchStore, devicesStore } = rootStore;
  scale = { ...scale, ...devicesStore.getDeviceById(scale.id) };
  const flowRateTolerancePercent = scale.flowRateTolerance || 10;
  const tolerance = flowRate * (flowRateTolerancePercent/100);
  const deviceStatus = batchStore.getDeviceStatus(scale.id);
  const defaultFlowRate = deviceStatus.flowRate || scale.flowRate;
  const isFlowRateBelow = flowRate < defaultFlowRate - tolerance;
  const isFlowRateAbove = flowRate > defaultFlowRate + tolerance;
  const bin = scale.decumulative && binForDecum ? devicesStore.getDeviceById(binForDecum.id) || binForDecum : null;
  const openDuration = bin?.openDuration ? bin.openDuration : scale.openDuration || 0.08;
  const closeDuration = bin?.closeDuration ? bin.closeDuration : scale.closeDuration || 0.08;
  const weight = batchStore.getScaleWeight(scale);
  const fullOpen = scale.fullOpen || 1;
  const fullOpenDuration = 3000;
  const openPort = scale.decumulative ? scalePorts.openPort : scale.openGateOnePNo;
  const closePort = scale.decumulative ? scalePorts.closePort : scale.closeGateOnePNo;

  if (scale.noFlowControl || runningData?.sequence?.noFlowControl) {
    return;
  }

  if (weight <= fullOpen) {
    batchStore.openScale(scale, fullOpenDuration, openPort, closePort);

    if (batchStore.isDoubleGateScale(scale)) {
      batchStore.openScale(scale, fullOpenDuration, scale.openGateTwoPNo, scale.closeGateTwoPNo);
    }

    logger.log(`scale #${scale.id} full open weight: ${fullOpen} open for ${fullOpenDuration}ms`);
    return;
  }

  if (isFlowRateBelow) {
    controlFlowRateBelow();
  } else if (isFlowRateAbove) {
    controlFlowRateAbove();
  }

  function controlFlowRateBelow() {
    const outputs = [];

    if (batchStore.isDoubleGateScale(scale)) {
      logger.log(`flow rate below, initial sent 1st gate: ${deviceStatus.firstGateInitialOpenSent}, 2nd gate: ${deviceStatus.secondGateInitialOpenSent}`);

      if (deviceStatus.firstGateInitialOpenSent) {
        outputs.push({ port: openPort, value: openDuration * 1000 });

        if (closePort) {
          outputs.push({ port: closePort, value: 0 });
        }
      }

      if (deviceStatus.secondGateInitialOpenSent) {
        outputs.push({ port: scale.openGateTwoPNo, value: openDuration * 1000 });

        if (scale.closeGateTwoPNo) {
          outputs.push({ port: scale.closeGateTwoPNo, value: 0 });
        }
      }

    } else {
      outputs.push({ port: openPort, value: openDuration * 1000 });

      if (closePort) {
        outputs.push({ port: closePort, value: 0 });
      }
    }

    batchStore.setOutputs(outputs);

    logger.log(`scale #${scale.id} flowRate ${flowRate} below ${defaultFlowRate} - ${tolerance}`);
  }

  function controlFlowRateAbove() {
    const outputs = [];

    if (batchStore.isDoubleGateScale(scale)) {
      logger.log(`flow rate above, initial sent 1st gate: ${deviceStatus.firstGateInitialOpenSent}, 2nd gate: ${deviceStatus.secondGateInitialOpenSent}`);

      if (deviceStatus.firstGateInitialOpenSent) {
        outputs.push({ port: openPort, value: 0 });

        if (closePort) {
          outputs.push({ port: closePort, value: closeDuration * 1000 });
        }
      }

      if (deviceStatus.secondGateInitialOpenSent) {
        outputs.push({ port: scale.openGateTwoPNo, value: 0 });

        if (scale.closeGateTwoPNo) {
          outputs.push({ port: scale.closeGateTwoPNo, value: closeDuration * 1000 });
        }
      }

    } else {
      outputs.push({ port: openPort, value: 0 });

      if (closePort) {
        outputs.push({ port: closePort, value: closeDuration * 1000 });
      }
    }

    batchStore.setOutputs(outputs);

    logger.log(`scale #${scale.id} flowRate ${flowRate} above ${defaultFlowRate} + ${tolerance}`);
  }

};
